/**
 * @module salutations
 * @description A list of salutations
 */

export const salutations = [
	'Mr',
	'Mrs',
	'Miss',
	'Dr',
	'Eng.',
	'Ms',
	'Prof',
	'Rev',
	'Lady',
	'Sir',
	'Capt',
	'Major',
	'Lt-col',
	'Col.',
] as const;
export type Salutations = (typeof salutations)[number];
